export enum AttendanceStatusCodes {
  OPEN = 1,
  AWAITING_APPROVAL_OF_PROJECT_MANAGER,
  AWAITING_APPROVAL_OF_PAYROLL_ADMIN,
  AWAITING_APPROVAL_OF_HEAD_OF_HR,
  APPROVED,
  REJECTED,
  CANCEL,
  AWAITING_TO_ASSIGN_LOCATION,
  AWAITING_TO_ASSIGN_TA_NUMBER,
  AWAITING_TO_ASSIGN_GROUP,
  AWAITING_TO_SYNC,
  AWAITING_APPROVAL,
  AWAITING_APPROVAL_OF_PROJECT_CONTROL,
}
